/**
 * The three trade-area pages: one component, three prerendered routes, each
 * aimed at its own search wording (see the trade-area-pages skill).
 *
 * Dependency-free on purpose: read by the router, the server routes, the
 * footer, the logo menu and scripts/sitemap-trade-area.ts (via tsx).
 */

/**
 * `trade_area` lets the visitor switch shape on the page; the other two are
 * pinned to theirs and link to each other instead.
 */
export type TradeAreaPageKind = 'radius' | 'drive' | 'trade_area';

export interface TradeAreaPageRoute {
  kind: TradeAreaPageKind;
  path: string;
  /** The `<title>`, also set by the router before the page boots. */
  title: string;
  /** The page's name in breadcrumbs, the footer and the logo menu. */
  label: string;
}

/** Route data key the page reads its kind from. */
export const TRADE_AREA_KIND_KEY = 'tradeAreaKind';

// The parent first: breadcrumbs, the footer and the menu list them in this
// order.
export const TRADE_AREA_PAGES: readonly TradeAreaPageRoute[] = [
  {
    kind: 'trade_area',
    path: 'trade-area-analysis',
    title: 'Trade Area Analysis for Retail Locations | Map AI',
    label: 'Trade area analysis',
  },
  {
    kind: 'radius',
    path: 'demographics-by-radius',
    title: 'Demographic Reports by Radius for Any US Address | Map AI',
    label: 'Demographics by radius',
  },
  {
    kind: 'drive',
    path: 'demographics-by-drive-time',
    title: 'Drive Time Demographics & Reports | Map AI',
    label: 'Demographics by drive time',
  },
];

export function tradeAreaPageRoute(
  kind: TradeAreaPageKind
): TradeAreaPageRoute {
  return TRADE_AREA_PAGES.find((page) => page.kind === kind)!;
}

/** Absolute path, for `routerLink`. */
export function tradeAreaPagePath(kind: TradeAreaPageKind): string {
  return `/${tradeAreaPageRoute(kind).path}`;
}
